import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthProfile } from '@/context/AuthContext';

export const RoleGuard: React.FC<{ roles: Array<'admin' | 'jogador'>; children: JSX.Element }> = ({ roles, children }) => {
  const { loading, profile } = useAuthProfile();
  if (loading) return null; // opcional: spinner
  if (!profile || !roles.includes(profile.role)) return <Navigate to="/" replace />;
  return children;
};